import { render, staticRenderFns } from "./PlaceholderQuestion.vue?vue&type=template&id=7df13800"
import script from "./PlaceholderQuestion.vue?vue&type=script&lang=js"
export * from "./PlaceholderQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports